<!-- 确认上户dialog 组件 -->
<template>
  <section class="dialog">
    <mt-popup v-model="confirmVisible">
      <div class="confirm-content">
        <div class="title">月嫂已发起上户确认</div>
        <div class="title">
          上户时间：<span class="red">{{ serviceTime }}</span>
        </div>
        <div class="sub-title" v-if="hasAppliedRefund">
          1.确认上户后会自动取消您的“退款申请”；<br />
          2.为了保障您的权益，请不要提前确认。
        </div>
        <!-- <div class="sub-title" v-if="hasAppliedRefund"> -->
        <!-- </div> -->
        <div class="sub-title" v-if="!hasAppliedRefund">
          为了保障您的权益，请不要提前确认。
        </div>
        <div class="confirm-btn" @click.once="confirmHandle(40)">
          确认月嫂上户
        </div>
        <div class="cancel-btn refuse-btn" @click.once="confirmHandle(35)">
          上户日期有误
        </div>
        <div class="cancel-btn" @click="confirmVisible = false">取消</div>
      </div>
    </mt-popup>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Popup } from 'mint-ui'
import { fetchConfirm2home, addWork } from '@/service/order'
import { B_ORDER_YS, isNewSelfAsignedMonthInLaw } from '@/business'

export default {
  inject: ['reload'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Popup.name]: Popup
  },
  data() {
    //这里存放数据
    return {
      confirmVisible: false
    }
  },
  props: {
    serviceTime: {
      default: '',
      type: String
    },
    order: {
      default: {},
      type: Object
    }
  },
  //监听属性 类似于data概念
  computed: {
    hasAppliedRefund() {
      //”refundState“：0 // 0申请 1 撤销 2 结束
      const { signRefundInfo = {} } = this.order || {}
      const { refundState = 1 } = signRefundInfo
      return B_ORDER_YS.hasAppliedRefund(refundState)
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.confirmVisible = true
    },
    confirmHandle(state) {
      const strMsg =
        state === 40 ? '操作成功' : '我们已经收到您的反馈，会及时联系月嫂处理'
      fetchConfirm2home(this.order, state).then(flag => {
        const str = `${flag ? strMsg : '操作失败'}`
        this.confirmVisible = false
        this.$$toast(str)
        if (state === 40 && flag) {
          this.$emit('showDialogNewServiceLogAndRefresh')
        } else {
          // 更新页面
          this.reload()
        }
      })
      if (isNewSelfAsignedMonthInLaw(this.order)) {
        // 生成修改上户时间工单
        addWork({
          workType: 2,
          serviceDemand: '月嫂',
          source: 7,
          sourceId: this.order.orderId,
          sourceType: 3
        })
      }
    },
    refuse2Home() {
      // TODO
      console.log('拒绝上户')
      fetchConfirm2home(this.order, 35).then(flag => {
        const str = `${
          flag ? '我们已经收到您的反馈，会及时联系月嫂处理' : '操作失败'
        }`
        this.confirmVisible = false
        this.$$toast(str)
        // 更新页面
        this.reload()
      })
    },

    doConfirm() {
      console.log('同意上户')
      // this.$$loading(true);
      fetchConfirm2home(this.order, 40).then(flag => {
        const str = `操作${flag ? '成功' : '失败'}`
        this.confirmVisible = false
        this.$$toast(str)
        // 更新页面
        this.reload()
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss">
.mint-popup {
  background: #ffffff;
  border-radius: 28px !important;
}
</style>
<style lang="scss" scope>
@import '~@/assets/css/mixin';
//@import url(); 引入公共css类
.dialog {
  .confirm-content {
    width: rem(560px);
    // height: rem(520px);
    background: #ffffff;
    border-radius: rem(28px);
    text-align: center;
    padding-top: rem(40px);
    .title {
      font-size: rem(32px);
      color: #262626;
      font-weight: 700;
      text-align: center;
      margin-bottom: rem(4px);
    }
    .red {
      color: #ff074c !important;
    }
    .sub-title {
      margin-top: rem(16px);
      font-size: rem(26px);
      color: #4d4d4d;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      padding-bottom: rem(32px);
    }
    .confirm-btn {
      height: rem(87px);
      line-height: rem(87px);
      font-size: rem(32px);
      font-weight: 700;
      font-size: 700;
      color: #ff397e;
      border-bottom: 1px solid #f0f0f0;
    }
    .refuse-btn {
      border-bottom: 1px solid #f0f0f0;
    }
    .cancel-btn {
      height: rem(87px);
      line-height: rem(87px);
      font-size: rem(32px);
      color: #ff397e;
    }
  }
}
</style>
